import { BREAKPOINT } from '../api'

const setLinkTargetTo = target => link => {
  link.setAttribute('target', target)
}

export default {
  init () {
    if (window.innerWidth >= BREAKPOINT.TABLET) {
      document.querySelectorAll('a[href*="offercode="]').forEach(setLinkTargetTo('_blank'))
    }
  },
}



// WEBPACK FOOTER //
// ./src/modules/customizations/openOfferLinkInNewWindow.js